<header class="app-navbar">

  <!-- ================= LEFT SECTION ================= -->
  <div class="app-navbar__left">
    <div class="app-navbar__item app-navbar__org-select app-navbar__org-select-wrapper">
      <!-- Custom styled trigger -->
      <div
        class="hidden lg:flex items-center gap-2 text-slate-800 hover:bg-slate-100 px-3 py-2 transition-colors app-navbar__org-trigger">
        <span>{{ orgDropdown.selectedOption?.label || 'Chọn tổ chức' }}</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
          class="w-4 h-4 text-slate-400">
          <path fill-rule="evenodd"
            d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z"
            clip-rule="evenodd"></path>
        </svg>
      </div>
      <!-- Hidden PrimeNG dropdown covering the visual trigger to handle clicks natively -->
      <p-dropdown #orgDropdown appendTo="body" [baseZIndex]="100" [autoDisplayFirst]="true" [filter]="true"
        [options]="data" (onChange)="changeOrganization($event)" [(ngModel)]="selectOrg" optionLabel="label"
        optionValue="value" placeholder="--- Chọn tổ chức ---" styleClass="custom-org-dropdown"
        class="app-navbar__org-dropdown-overlay">
      </p-dropdown>
    </div>

    <!-- Search Bar -->
    <div class="app-navbar__search">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
        class="app-navbar__search-icon">
        <path fill-rule="evenodd"
          d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z"
          clip-rule="evenodd"></path>
      </svg>
      <input class="app-navbar__search-input" placeholder="Tìm kiếm nhân viên, hợp đồng... (⌘K)" type="text"
        pInputText />
    </div>
    <!-- <button class="app-navbar__icon-btn hide-on-desktop" aria-label="Toggle Sidebar">
      <i class="pi pi-bars"></i>
    </button> -->
  </div>

  <!-- ================= RIGHT SECTION ================= -->
  <div class="app-navbar__right">

    <!-- Dark / Light Mode Toggle Button -->
    <button class="app-navbar__icon-btn" title="Chế độ sáng / tối">
      <!-- Moon Icon (dark mode) -->
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
        data-slot="icon" class="w-10 h-10">
        <path fill-rule="evenodd"
          d="M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z"
          clip-rule="evenodd"></path>
      </svg>
    </button>

    <!-- Text Color Picker Button -->
    <button class="app-navbar__icon-btn" title="Màu chữ">
      <!-- Letter A with color underline -->
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
        data-slot="icon" class="w-10 h-10">
        <path fill-rule="evenodd"
          d="M2.25 4.125c0-1.036.84-1.875 1.875-1.875h5.25c1.036 0 1.875.84 1.875 1.875V17.25a4.5 4.5 0 1 1-9 0V4.125Zm4.5 14.25a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
          clip-rule="evenodd"></path>
        <path
          d="M10.719 21.75h9.156c1.036 0 1.875-.84 1.875-1.875v-5.25c0-1.036-.84-1.875-1.875-1.875h-.14l-8.742 8.743c-.09.089-.18.175-.274.257ZM12.738 17.625l6.474-6.474a1.875 1.875 0 0 0 0-2.651L15.5 4.787a1.875 1.875 0 0 0-2.651 0l-.1.099V17.25c0 .126-.003.251-.01.375Z">
        </path>
      </svg>
    </button>

    <!-- Notifications Button -->
    <button class="app-navbar__icon-btn" title="Thông báo">
      <!-- Bell SVG Icon -->
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
        data-slot="icon" class="w-10 h-10">
        <path fill-rule="evenodd"
          d="M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0 25.057 25.057 0 0 1-4.496 0Z"
          clip-rule="evenodd"></path>
      </svg>
    </button>

    <!-- Help Button -->
    <button class="app-navbar__icon-btn" title="Trợ giúp">
      <!-- Circle Help (Question Mark) SVG Icon -->
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
        data-slot="icon" class="w-10 h-10">
        <path fill-rule="evenodd"
          d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm11.378-3.917c-.89-.777-2.366-.777-3.255 0a.75.75 0 0 1-.988-1.129c1.454-1.272 3.776-1.272 5.23 0 1.513 1.324 1.513 3.518 0 4.842a3.75 3.75 0 0 1-.837.552c-.676.328-1.028.774-1.028 1.152v.75a.75.75 0 0 1-1.5 0v-.75c0-1.279 1.06-2.107 1.875-2.502.182-.088.351-.199.503-.331.83-.727.83-1.857 0-2.584ZM12 18a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
          clip-rule="evenodd"></path>
      </svg>
    </button>

    <!-- Language Selector -->
    <div class="lang-selector">
      <!-- Trigger Button -->
      <button class="app-navbar__icon-btn lang-selector__btn"
        [class.lang-selector__btn--active]="isLanguageDropdownOpen" title="Chuyển đổi ngôn ngữ"
        (click)="languagePopover.toggle($event)">
        <!-- Globe SVG Icon -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#8e9abb" aria-hidden="true"
          data-slot="icon" class="w-13 h-13">
          <path
            d="M21.721 12.752a9.711 9.711 0 0 0-.945-5.003 12.754 12.754 0 0 1-4.339 2.708 18.991 18.991 0 0 1-.214 4.772 17.165 17.165 0 0 0 5.498-2.477ZM14.634 15.55a17.324 17.324 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 0 0 .332 4.647 17.385 17.385 0 0 0 5.268 0ZM9.772 17.119a18.963 18.963 0 0 0 4.456 0A17.182 17.182 0 0 1 12 21.724a17.18 17.18 0 0 1-2.228-4.605ZM7.777 15.23a18.87 18.87 0 0 1-.214-4.774 12.753 12.753 0 0 1-4.34-2.708 9.711 9.711 0 0 0-.944 5.004 17.165 17.165 0 0 0 5.498 2.477ZM21.356 14.752a9.765 9.765 0 0 1-7.478 6.817 18.64 18.64 0 0 0 1.988-4.718 18.627 18.627 0 0 0 5.49-2.098ZM2.644 14.752c1.682.971 3.53 1.688 5.49 2.099a18.64 18.64 0 0 0 1.988 4.718 9.765 9.765 0 0 1-7.478-6.816ZM13.878 2.43a9.755 9.755 0 0 1 6.116 3.986 11.267 11.267 0 0 1-3.746 2.504 18.63 18.63 0 0 0-2.37-6.49ZM12 2.276a17.152 17.152 0 0 1 2.805 7.121c-.897.23-1.837.353-2.805.353-.968 0-1.908-.122-2.805-.353A17.151 17.151 0 0 1 12 2.276ZM10.122 2.43a18.629 18.629 0 0 0-2.37 6.49 11.266 11.266 0 0 1-3.746-2.504 9.754 9.754 0 0 1 6.116-3.985Z">
          </path>
        </svg>
        <!-- Label ngôn ngữ hiện tại -->
        <!-- <span class="lang-selector__current">{{ currentLanguage | uppercase }}</span> -->
      </button>

      <!-- Language Dropdown (p-overlayPanel — PrimeNG 13) -->
      <p-overlayPanel #languagePopover [dismissable]="true"
        styleClass="!rounded-xl !shadow-[0_8px_32px_rgba(0,0,0,0.12)] !border !border-[#eef0f3] !mt-2 [&_.p-overlaypanel-content]:!p-0 before:!hidden after:!hidden"
        (onShow)="isLanguageDropdownOpen = true" (onHide)="isLanguageDropdownOpen = false">
        <div class="p-1.5 min-w-[150px] flex flex-col gap-0.5 bg-white">

          <!-- Option: Tiếng Việt -->
          <button
            class="flex items-center justify-between w-full px-3 py-2 border-none rounded-lg cursor-pointer text-[13px] text-gray-700 bg-transparent text-left transition-all duration-200 focus:outline-none"
            [ngClass]="currentLanguage === 'vi' ? 'bg-blue-50/80 text-blue-700 font-medium' : 'hover:bg-gray-100/80 hover:text-gray-900'"
            (click)="changeLanguage('vi'); languagePopover.hide()">
            <div class="flex items-center gap-2.5">
              <img
                src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20id='flag-icons-vn'%20viewBox='0%200%20640%20480'%3e%3cdefs%3e%3cclipPath%20id='vn-a'%3e%3cpath%20fill-opacity='.7'%20d='M-85.3%200h682.6v512H-85.3z'/%3e%3c/clipPath%3e%3c/defs%3e%3cg%20fill-rule='evenodd'%20clip-path='url(%23vn-a)'%20transform='translate(80)scale(.9375)'%3e%3cpath%20fill='%23da251d'%20d='M-128%200h768v512h-768z'/%3e%3cpath%20fill='%23ff0'%20d='M349.6%20381%20260%20314.3l-89%2067.3L204%20272l-89-67.7%20110.1-1%2034.2-109.4L294%20203l110.1.1-88.5%2068.4%2033.9%20109.6z'/%3e%3c/g%3e%3c/svg%3e"
                class="w-[22px] h-[16px] object-cover shadow-[0_1px_2px_rgba(0,0,0,0.15)] rounded-[2px]" alt="VN">
              <span>Tiếng Việt</span>
            </div>
            <!-- Active indicator (dấu chấm tròn) -->
            <div *ngIf="currentLanguage === 'vi'" class="w-1.5 h-1.5 rounded-full bg-blue-600 shrink-0 shadow-sm"></div>
          </button>

          <!-- Option: English -->
          <button
            class="flex items-center justify-between w-full px-3 py-2 border-none rounded-lg cursor-pointer text-[13px] text-gray-700 bg-transparent text-left transition-all duration-200 focus:outline-none"
            [ngClass]="currentLanguage === 'en' ? 'bg-blue-50/80 text-blue-700 font-medium' : 'hover:bg-gray-100/80 hover:text-gray-900'"
            (click)="changeLanguage('en'); languagePopover.hide()">
            <div class="flex items-center gap-2.5">
              <img
                src="data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2060%2030'%3e%3cclipPath%20id='a'%3e%3cpath%20d='M0%200v30h60V0z'/%3e%3c/clipPath%3e%3cclipPath%20id='b'%3e%3cpath%20d='M30%2015h30v15zv15H0zH0V0zV0h30z'/%3e%3c/clipPath%3e%3cg%20clip-path='url(%23a)'%3e%3cpath%20fill='%23012169'%20d='M0%200v30h60V0z'/%3e%3cpath%20stroke='%23fff'%20stroke-width='6'%20d='m0%200%2060%2030m0-30L0%2030'/%3e%3cpath%20stroke='%23C8102E'%20stroke-width='4'%20clip-path='url(%23b)'%20d='m0%200%2060%2030m0-30L0%2030'/%3e%3cpath%20stroke='%23fff'%20stroke-width='10'%20d='M30%200v30M0%2015h60'/%3e%3cpath%20stroke='%23C8102E'%20stroke-width='6'%20d='M30%200v30M0%2015h60'/%3e%3c/g%3e%3c/svg%3e"
                class="w-[22px] h-[16px] object-cover shadow-[0_1px_2px_rgba(0,0,0,0.15)] rounded-[2px]" alt="EN">
              <span>English</span>
            </div>
            <div *ngIf="currentLanguage === 'en'" class="w-1.5 h-1.5 rounded-full bg-blue-600 shrink-0 shadow-sm"></div>
          </button>

        </div>
      </p-overlayPanel>
    </div>


    <!-- (App Grid) -->
    <div class="relative">
      <button [class.module-btn--active]="isModuleDropdownOpen" class="app-navbar__icon-btn"
        (click)="optionTopbar.toggle($event)" aria-label="Apps Module">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"
          data-slot="icon" class="w-10 h-10">
          <path fill-rule="evenodd"
            d="M3 6a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3V6ZM3 15.75a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2.25Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3v-2.25Z"
            clip-rule="evenodd"></path>
        </svg>
      </button>

      <!-- Module Dropdown using p-overlayPanel (PrimeNG 13) -->
      <p-overlayPanel #optionTopbar [dismissable]="true" styleClass="module-popover"
        (onShow)="isModuleDropdownOpen = true" (onHide)="isModuleDropdownOpen = false">
        <div class="module-popover__container">

          <!-- Header -->
          <div class="module-popover__header">
            <h3 class="module-popover__title text-md font-medium">Các Module</h3>
            <p class="module-popover__subtitle">Chọn module để truy cập</p>
          </div>

          <!-- Body: Grid 3 cột -->
          <div class="module-popover__grid" *ngIf="cats && cats.length > 0">
            <a *ngFor="let cat of cats" [href]="cat.webUrl" class="module-popover__item">
              <div class="module-popover__icon">
                <ng-container *ngIf="useModuleNgIcon(cat); else primeModuleIcon">
                  <ng-icon [name]="moduleIconNgName(cat)" size="48"></ng-icon>
                </ng-container>
                <ng-template #primeModuleIcon>
                  <i class="{{ cat.iconClass || 'pi pi-box' }}"></i>
                </ng-template>
              </div>
              <p class="module-popover__name">{{ cat.webName }}</p>
            </a>
          </div>

          <!-- Footer -->
          <div class="module-popover__footer">
            <button class="module-popover__footer-btn" (click)="optionTopbar.hide()">
              <i class="pi pi-plus"></i>
              Xem tất cả module
            </button>
          </div>

        </div>
      </p-overlayPanel>
    </div>

    <!-- User Profile Dropdown -->
    <div class="relative cursor-pointer app-navbar__user-trigger" (click)="menu.toggle($event)">
      <div class="app-navbar__user-card">
        <!-- Avatar -->
        <img src="../../../assets/images/walter.jpg" alt="User Avatar" class="app-navbar__user-avatar" />

        <!-- User Info -->
        <div class="hide-on-mobile app-navbar__user-info">
          <span class="app-navbar__user-name">{{
            userName }}</span>
          <span class="app-navbar__user-email">manhng@unicloud.com.vn</span>
        </div>
      </div>
    </div>

    <!-- User Prime Menu Popover -->
    <p-menu #menu [popup]="true" [model]="items" styleClass="custom-user-menu"></p-menu>

  </div>
</header>

<!-- Modal: Đổi Mật Khẩu -->
<p-dialog [(visible)]="isShowChangePassword" [modal]="true" styleClass="custom-dialog app-dialog-500-auto">
  <p-header>
    Cập nhật mật khẩu tài khoản <span class="text-primary">[{{userName}}]</span>
  </p-header>
  <form #editSMSF="ngForm" class="form-horizontal">
    <div class="form-group">
      <label class="form-label">Mật khẩu mới <span class="text-danger">*</span></label>
      <input type="password" class="form-control" name="userPassword" autocomplete="off" (change)="checkPasswordcf()"
        [(ngModel)]="modelPass.userPassword" required placeholder="Nhập mật khẩu mới">
      <div *ngIf="submitPass && !modelPass.userPassword" class="text-danger text-sm mt-1">
        Mật khẩu bắt buộc nhập!
      </div>
    </div>
    <div class="form-group mt-3">
      <label class="form-label">Nhập lại mật khẩu <span class="text-danger">*</span></label>
      <input type="password" class="form-control" name="userPassCf" autocomplete="off" (change)="checkPasswordcf()"
        [(ngModel)]="modelPass.userPassCf" required placeholder="Nhập lại mật khẩu">
      <div *ngIf="submitPass && (!modelPass.userPassCf || confimPassword)" class="text-danger text-sm mt-1">
        Mật khẩu không trùng khớp hoặc chưa nhập!
      </div>
    </div>
    <div class="dialog-footer text-right mt-4">
      <p-button label="Hủy" styleClass="p-button-text p-button-secondary mr-2"
        (click)="isShowChangePassword = false"></p-button>
      <p-button label="Lưu thay đổi" (click)="saveChangePass()"></p-button>
    </div>
  </form>
</p-dialog>


<!-- Modal: Cấu Hình IP -->
<p-dialog [(visible)]="isShowIpClient" [modal]="true" styleClass="custom-dialog app-dialog-500-auto">
  <p-header>Cấu hình IP Client</p-header>
  <form #editIPForm="ngForm" class="form-horizontal">
    <div class="form-group">
      <label class="form-label">Nhập Địa Chỉ IP <span class="text-danger">*</span></label>
      <input type="text" class="form-control" name="ipclient" autocomplete="off" [(ngModel)]="modelIpUser.ipclient"
        required placeholder="Ví dụ: 192.168.1.1">
      <div *ngIf="submitIP && !modelIpUser.ipclient" class="text-danger text-sm mt-1">
        Địa chỉ IP là bắt buộc!
      </div>
    </div>
    <div class="dialog-footer text-right mt-4">
      <p-button label="Hủy" styleClass="p-button-text p-button-secondary mr-2" (click)="cancel()"></p-button>
      <p-button label="Lưu lại" (click)="saveIP()"></p-button>
    </div>
  </form>
</p-dialog>